module.exports = __webpack_public_path__ + "img/logo.8ee88c9a.svg";